import { BadgeCheck, LockKeyhole, ShieldCheck, Sparkles, Zap } from "lucide-react";
import { Card, CardContent } from "../Card";
import { CheckoutButton } from "./CheckoutButton";
import { purchaseBenefits, specialPromotions } from "../../data/aquagym";
interface OfferSectionProps {
  repeated?: boolean;
}
const trustIcons = [{
  Icon: LockKeyhole,
  color: "text-emerald-400"
}, {
  Icon: Zap,
  color: "text-yellow-400"
}, {
  Icon: ShieldCheck,
  color: "text-cyan-400"
}, {
  Icon: BadgeCheck,
  color: "text-blue-400"
}];
export function OfferSection({
  repeated = false
}: OfferSectionProps) {
  return <section className="bg-[#0F172A] px-5 py-12 text-white sm:px-8 sm:py-16 lg:px-10" data-id="element-105" data-mp="2oesatmpig7a8">
      <div className="mx-auto w-full max-w-5xl" data-id="element-106" data-mp="2tdltdtjnmoh9">
        <header className="mx-auto max-w-3xl text-center" data-id="element-107" data-mp="2teeotyd5xrk3">
          <p className="text-xs font-black uppercase tracking-[0.18em] text-[#22D3EE]" data-id="element-108" data-mp="3ojq4rcflnjv">Una única oferta completa</p>
          <h2 className="mt-3 font-heading text-3xl font-black tracking-tight sm:text-5xl" data-id="element-109" data-mp="8mlbxk18s0z1">ELEGÍ AQUAGYM RESUELTO</h2>
          {!repeated ? <p className="mx-auto mt-3 max-w-2xl text-sm leading-6 text-slate-300 sm:text-base" data-id="element-110" data-mp="3h73bcrk4c1k5">
              Una única oferta completa para organizar tus clases, mejorar tus progresiones y trabajar con más seguridad profesional.
            </p> : null}
        </header>

        <Card className="mx-auto mt-7 overflow-hidden rounded-3xl border border-cyan-400/60 bg-[#18243B] text-white shadow-[0_26px_70px_rgba(0,0,0,0.32)]" data-id="element-111" data-mp="337ljg3bj086k">
          <CardContent className="p-0" data-id="element-112" data-mp="2ths915n4dz3w">
            <div className="flex flex-col gap-3 border-b border-white/10 px-5 py-5 text-center sm:flex-row sm:items-center sm:justify-between sm:px-7 sm:text-left" data-id="element-113" data-mp="2tgqxz163tcm6">
              <div data-id="element-114" data-mp="2ki5ft74jnzlx">
                <p className="text-[10px] font-black uppercase tracking-[0.18em] text-cyan-300" data-id="element-115" data-mp="2kix2fsg5yn02">AQUAGYM RESUELTO™ — SISTEMA COMPLETO</p>
                <h3 className="mt-1 text-2xl font-black sm:text-3xl" data-id="element-116" data-mp="2fkn9zpltq0i5">7 Tomos + 5 Bonos</h3>
              </div>
              <span className="mx-auto inline-flex rounded-full border border-cyan-400/40 bg-cyan-400/10 px-3 py-1.5 text-xs font-black text-cyan-300 sm:mx-0" data-id="element-117" data-mp="2alsgntq8ctjs">
                OFERTA ÚNICA
              </span>
            </div>

            <div className="bg-white p-4 text-[#1E293B] sm:p-5" data-id="element-118" data-mp="1rvnot7qxz26i">
              <p className="flex items-center justify-center gap-2 text-center text-[11px] font-black uppercase tracking-[0.13em] text-[#075985] sm:text-xs" data-id="element-119" data-mp="1rxi9ckyawsa2">
                <Sparkles className="size-4 text-[#06B6D4]" aria-hidden="true" data-id="element-120" data-mp="2jnmmpznn8f1s" />
                PROMOCIÓN ESPECIAL — INCLUIDOS COMPRANDO HOY
              </p>
              <div className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-121" data-mp="2au9lmaffe74m">
                {specialPromotions.map(promotion => <article key={promotion.title} className="grid min-h-32 grid-cols-[112px_1fr] overflow-hidden rounded-2xl border border-[#E2E8F0] bg-[#F8FAFC] shadow-sm sm:grid-cols-[128px_1fr]" data-id="element-122" data-mp="2eutn1q717wwk">
                    <img src={promotion.image} alt={`Presentación premium de ${promotion.title}`} className="h-full min-h-32 w-full object-cover" data-id="element-123" data-mp="37c602tljvi0q" />
                    <div className="flex min-w-0 flex-col justify-center p-3.5" data-id="element-124" data-mp="qxkdckvrq6jq">
                      <span className="mb-1.5 w-fit rounded-full bg-[#CFFAFE] px-2 py-0.5 text-[9px] font-black uppercase tracking-wide text-[#075985]" data-id="element-125" data-mp="15lf8s915up0i">Incluido hoy</span>
                      <h4 className="text-sm font-black leading-tight text-[#0C4A6E] sm:text-base" data-id="element-126" data-mp="cxjfleasvf8h">{promotion.title}</h4>
                      <p className="mt-1.5 line-clamp-3 text-[10px] leading-4 text-[#475569] sm:text-xs" data-id="element-127" data-mp="809qy0v8j7lp">{promotion.detail}</p>
                    </div>
                  </article>)}
              </div>
            </div>

            <div className="px-5 py-6 text-center sm:px-7 sm:py-7" data-id="element-128" data-mp="hz8rsx9rdyy5">
              <div className="flex flex-wrap items-end justify-center gap-x-3 gap-y-1" data-id="element-129" data-mp="1ya2w0a5gzogp">
                <p className="text-sm font-bold text-slate-400" data-id="element-130" data-mp="1tb9k2m5u05in">Antes <span className="ml-1 line-through decoration-rose-400 decoration-2" data-id="element-131" data-mp="1tenodzy22osq">$49.900 ARS</span></p>
                <span className="text-xs font-black uppercase tracking-[0.12em] text-cyan-300" data-id="element-132" data-mp="7uahkkpw5tve">Precio de oferta</span>
              </div>
              <p className="mt-1 text-5xl font-black tracking-tight text-white sm:text-6xl" data-id="element-133" data-mp="buuatd7cgdc9">$19.900 <span className="text-lg text-cyan-300" data-id="element-134" data-mp="gv8md585m5f1">ARS</span></p>
              <div className="mx-auto mt-5 flex justify-center" data-id="element-135" data-mp="lu32fzeqlfvg">
                <CheckoutButton label="SÍ, QUIERO MI AQUAGYM RESUELTO" data-id="element-136" data-mp="ltjtv9az83u3" />
              </div>

              <ul className="mx-auto mt-5 grid max-w-3xl grid-cols-2 overflow-hidden rounded-2xl border border-white/10 bg-[#111C30] sm:grid-cols-4 sm:divide-x sm:divide-white/10" data-id="element-137" data-mp="qrldpwg8876m">
                {purchaseBenefits.map((benefit, index) => {
                const {
                  Icon,
                  color
                } = trustIcons[index];
                return <li key={benefit} className="flex min-h-14 items-center justify-center gap-2 border-white/10 px-2.5 py-3 text-[11px] font-bold text-slate-200 odd:border-r sm:border-r-0 sm:text-xs" data-id="element-138" data-mp="14iq6qfp3a17z" data-mpi={index}>
                      <Icon className={`size-4 shrink-0 ${color}`} strokeWidth={2.2} aria-hidden="true" data-id="element-139" data-mp="1eoho128jkdzq" />
                      <span data-id="element-140" data-mp="19pevuidnu296">{benefit}</span>
                    </li>;
              })}
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}